/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Entity_PropertyInputs */

const cs_import_entity_property = /** @type {(inputs: Import_Entity_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti`)
};

const en_import_entity_property = /** @type {(inputs: Import_Entity_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties`)
};

/**
* | output |
* | --- |
* | "Properties" |
*
* @param {Import_Entity_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_entity_property = /** @type {((inputs?: Import_Entity_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Entity_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_entity_property(inputs)
	return cs_import_entity_property(inputs)
});